import confirmActions from './widgets/confirmation.actions';

let htmlInitial; // Cache the previously seen html

/**
 * Periodically check for updates to the UI.
 *
 * Inspired by https://marmelab.com/blog/2016/08/29/auto-reload-spa-on-mobile-setinterval.html
 */
const checkForUpdates = dispatch => () => {
	fetch(window.location.origin)
		.then(resp => (resp.status === 200 ? resp.text() : null))
		.then(htmlLatest => {
			if (!htmlLatest) return; // Do nothing if valid html not received

			if (htmlInitial) {
				// If the HTML has changed since initial loading, show reload prompt
				if (htmlInitial !== htmlLatest) {
					dispatch(
						confirmActions.open({
							title: 'New version available',
							message:
								'A new version of B2Me became available since you loaded the page. Please reload to get the latest changes.',
							onConfirm: () => window.location.reload(true),
							data: 'newVersion'
						})
					);
				}
			} else {
				htmlInitial = htmlLatest; // Save the initial html content found
			}
		});
};

export default checkForUpdates;



// WEBPACK FOOTER //
// ./src/checkForUpdates.js